import { gql } from "@apollo/client";
import { SUPPORT_TICKET_THREAD_DATA } from "./queries-gql";

export const GOOGLE_LOGIN = gql`
  mutation googleLogin($token: String!, $captcha: String!) {
    googleLogin(token: $token, captcha: $captcha) {
      authenticated
      token
    }
  }
`;

export const APPROVE_PHOTO = gql`
  mutation approvePhoto($uploadId: String!, $value: Boolean!) {
    approvePhoto(uploadId: $uploadId, value: $value)
  }
`;

export const REJECT_USER_PHOTO = gql`
  mutation rejectUserPhoto($userId: String!, $uploadId: String!) {
    rejectUserPhoto(userId: $userId, uploadId: $uploadId)
  }
`;

export const APPROVE_VIDEO = gql`
  mutation approveVideo($uploadId: String!, $value: Boolean!) {
    approveVideo(uploadId: $uploadId, value: $value)
  }
`;

export const SET_USER_GENDER = gql`
  mutation setUserGender($userId: String!, $gender: Gender!) {
    setUserGender(userId: $userId, gender: $gender)
  }
`;

export const SET_BAN = gql`
  mutation setBan($_id: String!, $value: Boolean!, $until: DateTime) {
    setBan(_id: $_id, value: $value, until: $until)
  }
`;

export const CALC_POPULARITY = gql`
  mutation calcPopularity {
    calcPopularity
  }
`;

export const FIX_PHOTOS = gql`
  mutation fixPhotos {
    fixPhotos
  }
`;

export const RESET_PROFILE_PHOTO_APPROVAL = gql`
  mutation resetProfilePhotoApproval($userId: String!) {
    resetProfilePhotoApproval(userId: $userId)
  }
`;

export const APPROVE_PROFILE_PHOTO = gql`
  mutation approveProfilePhoto(
    $userId: String!
    $value: Boolean!
    $rejectReason: PhotoRejectReason
  ) {
    approveProfilePhoto(
      userId: $userId
      value: $value
      rejectReason: $rejectReason
    )
  }
`;

export const APPROVE_MATCH_VIDEO = gql`
  mutation approveMatchVideo($userId: String!, $value: Boolean!) {
    approveMatchVideo(userId: $userId, value: $value)
  }
`;

export const APPROVE_REEL = gql`
  mutation approveReel(
    $reelId: String!
    $value: Boolean!
    $rejectReason: ReelRejectReason!
    $explicit: Boolean!
    $matchVideo: Boolean!
  ) {
    approveReel(
      reelId: $reelId
      value: $value
      rejectReason: $rejectReason
      explicit: $explicit
      matchVideo: $matchVideo
    )
  }
`;

export const DELETE_REEL = gql`
  mutation deleteReel($reelId: String!) {
    deleteReel(reelId: $reelId)
  }
`;

export const PROMOTE_REEL = gql`
  mutation promoteReel($reelId: String!) {
    promoteReel(reelId: $reelId)
  }
`;

export const SET_REEL_EXPLICIT = gql`
  mutation setReelExplicit($reelId: String!, $explicit: Boolean!) {
    setReelExplicit(reelId: $reelId, explicit: $explicit)
  }
`;

export const SET_REEL_DESCRIPTION = gql`
  mutation setReelDescription($reelId: String!, $description: String!) {
    setReelDescription(reelId: $reelId, description: $description)
  }
`;

export const MARK_REEL_FOR_HLS_CONVERT = gql`
  mutation markReelForHlsConvert($reelId: String!) {
    markReelForHlsConvert(reelId: $reelId)
  }
`;

export const APPROVE_PHOTO_VERIFICATION = gql`
  mutation approvePhotoVerification($userId: String!, $value: Boolean!) {
    approvePhotoVerification(userId: $userId, value: $value)
  }
`;

export const REVIEW_POST = gql`
  mutation reviewPost($postId: String!, $reviewStatus: PostReviewStatus!) {
    reviewPost(postId: $postId, reviewStatus: $reviewStatus)
  }
`;

export const APPROVE_GROUP_PHOTO = gql`
  mutation approveGroupPhoto($groupId: String!, $value: Boolean!) {
    approveGroupPhoto(groupId: $groupId, value: $value)
  }
`;

export const APPROVE_GROUP = gql`
  mutation approveGroup($groupId: String!, $value: Boolean!) {
    approveGroup(groupId: $groupId, value: $value)
  }
`;

export const DELETE_USER = gql`
  mutation deleteUser($userId: String!) {
    deleteUser(userId: $userId)
  }
`;

export const SEND_PUSH = gql`
  mutation sendPush($args: SendPushArgs!) {
    sendPush(args: $args)
  }
`;

export const FIX_MAN = gql`
  mutation fixMan($userId: String!) {
    fixMan(userId: $userId)
  }
`;

export const DELETE_VOICE_RECORDING = gql`
  mutation deleteVoiceRecording($userId: String!, $uploadId: String!) {
    deleteVoiceRecording(userId: $userId, uploadId: $uploadId)
  }
`;

export const DELETE_REEL_COMMENT = gql`
  mutation deleteReelComment($commentId: String!) {
    deleteReelComment(commentId: $commentId)
  }
`;

export const END_LIVE_STREAM = gql`
  mutation endLiveStream($streamId: String!) {
    endLiveStream(streamId: $streamId)
  }
`;

export const BAN_USER_FROM_LIVE_STREAMING = gql`
  mutation banUserFromLiveStreaming($streamId: String!, $userId: String!) {
    banUserFromLiveStreaming(streamId: $streamId, userId: $userId)
  }
`;

export const SET_LIVE_BAN = gql`
  mutation setLiveBan($userId: String!, $value: Boolean!) {
    setLiveBan(userId: $userId, value: $value)
  }
`;

export const SET_LIVE_STREAMING_APPROVED = gql`
  mutation setLiveStreamingApproved(
    $userId: String!
    $value: Boolean!
    $reason: String
    $retryAfterDays: Int
  ) {
    setLiveStreamingApproved(
      userId: $userId
      value: $value
      reason: $reason
      retryAfterDays: $retryAfterDays
    )
  }
`;

export const UPLOAD_REEL_THUMBNAIL = gql`
  mutation uploadReelThumbnail($reelId: String!, $contentType: String!, $contentLength: String!, $fileName: String!) {
    uploadReelThumbnail(reelId: $reelId, contentType: $contentType, contentLength: $contentLength, fileName: $fileName) {
      uploadId
      uploadPostInfo {
        postUrl
        fileName
        fields {
          key
          value
        }
      }
    }
  }
`;

export const REPLY_SUPPORT_TICKET = gql`
  mutation replySupportTicket($_id: String!, $text: String!, $resolve: Boolean!) {
    replySupportTicket(_id: $_id, text: $text, resolve: $resolve) {
      ...SupportTicketThreadData
    }
  }
  ${SUPPORT_TICKET_THREAD_DATA}
`;

export const SET_SUPPORT_TICKET_STATUS = gql`
  mutation setSupportTicketStatus(
    $_id: String!
    $status: String!
    $note: String
    $snoozeDays: Int
  ) {
    setSupportTicketStatus(
      _id: $_id
      status: $status
      note: $note
      snoozeDays: $snoozeDays
    ) {
      ...SupportTicketThreadData
    }
  }
  ${SUPPORT_TICKET_THREAD_DATA}
`;

export const ADD_SUPPORT_TICKET_NOTE = gql`
  mutation addSupportTicketNote($_id: String!, $text: String!) {
    addSupportTicketNote(_id: $_id, text: $text) {
      ...SupportTicketThreadData
    }
  }
  ${SUPPORT_TICKET_THREAD_DATA}
`;
